import styled from "@emotion/styled";
import { theme } from "@styles/theme";
const { sm, md, lg, xl } = theme.breakpoints;
export const Container = styled.div`
  background-image: url("https://res.cloudinary.com/ds8crblmm/image/upload/v1611603045/bonadona/Group_1561_hho65w.jpg");
  display: flex;
  flex-direction: column;
`;
export const Header = styled.div`
  display: flex;
`;
export const BackContainer = styled.div`
  display: flex;
  margin: 1em;
  margin-bottom: 0;
  font-family: "Poppins Regular";
  color: white;
  align-items: center;
  font-size: 1em;
  cursor: pointer;
  /*  @media (max-width: ${sm}) {
    font-size: 9px;
  } */
`;
export const Back = styled.div`
  font-family: "Poppins Medium";
  font-size: 1.4em;
  margin-right: 0.2em;
`;
export const Content = styled.div`
  margin: 3em 4em;
  /* display: flex;
  justify-content: space-between;*/
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  @media (max-width: ${lg}) {
    grid-template-columns: repeat(2, 1fr);
    grid-row-gap: 2em;
    margin: 2em 4em;
  }
  @media (max-width: ${sm}) {
    font-size: 9px;
  }
`;
export const Label = styled.div`
  display: flex;
  align-items: center;
  font-family: Poppins Regular;
  color: white;
  @media (max-width: ${lg}) {
    flex-direction: column;
  }
`;
export const Value = styled.div`
  background-color: white;
  color: #1b1c1e;
  padding: 0.5em 0.5em;
  font-size: 1.1em;
  min-width: 10em;
  border-radius: 1em;
  text-align: center;
  margin-left: 0.8em;
  @media (max-width: ${lg}) {
    margin-top: 0.5em;
  }
`;
